export const RESET = 'SERVER_UPDATE_RESET'
export const SET_ERROR = 'SERVER_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'SERVER_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'SERVER_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'SERVER_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'SERVER_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'SERVER_UPDATE_UPDATE_RETRIEVED'
